import moment from 'moment';

moment.locale('de');
